import React from 'react';
import {Link} from 'react-router-dom';
import style from './style.scss';

class NewsItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <section className="news-item">
        <div className='news-item-left-content'>
          <div className='news-item-wrap-img'>
            <img className='news-item-img' src={require('assets/images/slider/slider-1.png')} alt=''/>
          </div>
          <div className='news-item-detail'>
            <h2 className='news-item-titel'>Hội chợ hàng Việt Nam 2017</h2>
            <p className='news-item-time'>Từ ngày 18/10 đến 18/11</p>
            <p className='news-item-desciption'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer vitae lorem non metus vestibulum volutpat at eu ante.
            Aliquam eu est sagittis, malesuada lectus non, pharetra felis. Curabitur justo est, porttitor eu ultricies sit amet, molestie ut risus. </p>
          </div>
        </div>
        <div className='news-item-right-action'>
          <Link className='button-add-product' to='/my-business/post-product'>Đăng sản phẩm</Link>
          <Link to='/my-business/products' className='product-manage'>Quản lý sản phẩm</Link>
        </div>
      </section>
    );
  }
}

export default NewsItem;



// WEBPACK FOOTER //
// ./components/my-business/sub-view/the-news/news/NewsItem.jsx